import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import FieldError           from '../Fragments/FieldError';

let Quote = require('../Managers/Quote.js');
let Validation = require('../Managers/Validation.js');
let Config = require('Config');

class TextareaInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHelpVisible: false,
            isCounterActive: false,
            currentCounterCount: 0,
            activeValue: props.defaultValue ? props.defaultValue : null,
        };
    }

    onBlur(e) {
        e.persist();
        this.setState({ isCounterActive: false }, () => {
            this.handleValidation(e);
        });
    }

    onFocus() {
        this.setState({ isCounterActive: true });
    }

    onKeyUp(e) {
        e.persist();
        if (this.props.hasCountdown) {
            this.setState({currentCounterCount: e.target.value.length});
        }
    }

    onKeyDown(e) {
        e.persist();
        if (this.props.hasCountdown) {
            if (Config.reactNonPrintableKeys.indexOf(e.key) === -1) {
                const length = e.target.value.length + 1;

                if (length > this.props.countdownMax) {
                    e.preventDefault();
                }
            }
        }
    }

    handleValidation(e) {
        e.persist();
        let val = e.target.value;

        let validation = Validation.validate(this.props.dataValidation, val, 'not_null')[0];
        this.setState(Object.assign({}, validation, { activeValue: val }), () => {
            this.props.isValid(validation.isValid);
        });

        Quote.set(this.props.storageKey, val, this.props.source);
        Quote.setAnswer(this.props.storageKey, val);

        if (this.props.callbackFunction) {
            this.props.callbackFunction(val);
        }
    }

    render() {
        let counterClass = "counter";

        if (this.state.isCounterActive) {
            counterClass += " active";
        }

        return (
            <div className="question-input">
                <textarea
                    defaultValue={this.state.activeValue}
                    onChange={this.handleChange}
                    onBlur={this.onBlur.bind(this)}
                    onFocus={this.onFocus.bind(this)}
                    onKeyUp={this.onKeyUp.bind(this)}
                    onKeyDown={this.onKeyDown.bind(this)}
                    className="form-control"
                    ref={(myTextarea) => {this.myTextarea = myTextarea;}}
                    rows={8}
                />

                {this.props.hasCountdown ?
                    <question-row>
                        <span className={counterClass}>
                            {this.state.currentCounterCount} characters used ({this.props.countdownMax} limit)
                        </span>
                    </question-row>
                : null}

                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}
            </div>
        );
    }
}

TextareaInput.propTypes = {
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string,
    question:           PropTypes.string.isRequired,
    hasCountdown:       PropTypes.bool,
    countdownMax:       PropTypes.number,
    callbackFunction:   PropTypes.func,
    defaultValue:       PropTypes.string,
    dataValidation:     PropTypes.string,
    source:             PropTypes.string,
    isValid:            PropTypes.func,
};

export default TextareaInput;


// WEBPACK FOOTER //
// ./src/components/Fields/TextareaInput.js